import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Sparkles, Star, Calendar } from 'lucide-react';

const professions = ['Nepali Pandit', 'Astrologer', 'Hindu Priest'];

const Home = () => {
  const [profIdx, setProfIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setProfIdx((prev) => (prev + 1) % professions.length);
        setVisible(true);
      }, 450);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-shell">
      {/* Keyframe styles */}
      <style>{`
        @keyframes fadeSlideIn {
          0%   { opacity: 0; transform: translateY(18px); }
          100% { opacity: 1; transform: translateY(0px); }
        }
        @keyframes fadeSlideOut {
          0%   { opacity: 1; transform: translateY(0px); }
          100% { opacity: 0; transform: translateY(-18px); }
        }
        .prof-visible { animation: fadeSlideIn 0.45s cubic-bezier(0.22,1,0.36,1) forwards; }
        .prof-hidden  { animation: fadeSlideOut 0.45s cubic-bezier(0.22,1,0.36,1) forwards; }
      `}</style>

      {/* Two-column layout */}
      <div className="home-inner">

        {/* ── LEFT CONTENT ─────────────────────────────────── */}
        <div className="home-left">

          {/* Badge */}
          <div className="appt-hero-badge home-badge">
            <Star size={14} />
            <span>Vedic Pujari &amp; Astrologer</span>
          </div>

          {/* Name heading */}
          <div className="home-title-block">
            <h1 className="home-main-title">
              Hi, I'm{' '}
              <span className="home-name-gradient">Prakash</span>
            </h1>

            {/* Animated profession */}
            <div className="home-profession-wrap">
              <h2
                key={profIdx}
                className={`home-profession ${visible ? 'prof-visible' : 'prof-hidden'}`}
              >
                <span className="home-profession-prefix">This is </span>
                <span className="home-profession-value">{professions[profIdx]}</span>
              </h2>
            </div>

            {/* Indicator dots */}
            <div className="home-dots">
              {professions.map((_, i) => (
                <button
                  key={i}
                  onClick={() => { setVisible(false); setTimeout(() => { setProfIdx(i); setVisible(true); }, 450); }}
                  className={`home-dot ${i === profIdx ? 'active' : ''}`}
                  aria-label={`Show ${professions[i]}`}
                />
              ))}
            </div>
          </div>

          {/* Subtext */}
          <p className="home-subtext">
            Belief in <span className="home-subtext-accent">God</span>. Everything will change and your broken heart will be filled with joy and happiness.
          </p>

          {/* Mobile-only Image */}
          <div className="home-mobile-photo-wrap">
            <img
              src="/sidephoto.png"
              alt="Prakash Upadhyaya"
              className="home-photo-mobile"
            />
          </div>

          {/* CTA Buttons */}
          <div className="home-ctas">
            <Link to="/services" className="appt-btn-primary home-cta-primary" id="home-cta-services">
              Our Services
            </Link>
            <Link to="/appointment" className="home-cta-book" id="home-cta-book">
              <Calendar size={16} />
              Book Appointment
            </Link>
            <Link to="/contact" className="home-cta-outline" id="home-cta-contact">
              Contact
            </Link>
          </div>

          {/* Contact Details */}
          <div className="home-contact-strip">
            <a href="mailto:Prakashupadhyaya835@gmail.com" className="home-contact-item">
              <Mail size={14} />
              Prakashupadhyaya835@gmail.com
            </a>
            <a href="tel:+61416656862" className="home-contact-item">
              <Phone size={14} />
              +61 416 656 862
            </a>
            <div className="home-contact-item">
              <MapPin size={14} />
              26 Naretha Court, Morayfield QLD 4506
            </div>
          </div>

        </div>

        {/* ── RIGHT PHOTO ───────────────────────────────────── */}
        <div className="home-right">
          {/* Decorative glow */}
          <div className="home-glow" />
          {/* Floating orbs */}
          <div className="home-orb home-orb-1" />
          <div className="home-orb home-orb-2" />

          <img
            src="/sidephoto.png"
            alt="Prakash Upadhyaya"
            className="home-photo"
          />
        </div>

      </div>
    </div>
  );
};

export default Home;
